import React, { useState } from 'react';
import {
  LayoutRectangle,
  NativeScrollEvent,
  ScrollView,
  ScrollViewProps,
  StyleSheet,
  View,
} from 'react-native';

import { LinearGradient } from 'expo-linear-gradient';

import { BACKGROUND_COLOR } from '../constants/Colors';

export default (props: ScrollViewProps) => {
  const [scrollEvent, setScrollEvent] = useState<NativeScrollEvent>();
  const [scrollViewLayout, setScrollViewLayout] = useState<LayoutRectangle>();

  const isSmallScreen = scrollViewLayout?.width < 500;

  return (
    <View>
      <ScrollView
        showsHorizontalScrollIndicator={false}
        horizontal
        style={styles.container}
        contentContainerStyle={
          isSmallScreen
            ? styles.contentContainerSmallScreen
            : styles.contentContainerLargeScreen
        }
        onScroll={(event) => {
          setScrollEvent(event.nativeEvent);
        }}
        onLayout={(event) => {
          setScrollViewLayout(event.nativeEvent.layout);
        }}
        scrollEventThrottle={60}
      >
        {props.children}
      </ScrollView>
      {isSmallScreen && (
        <>
          {scrollEvent && scrollEvent?.contentOffset.x > 0 && (
            <LinearGradient
              colors={[BACKGROUND_COLOR, 'transparent']}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              style={styles.fadeLeft}
            />
          )}
          {(!scrollEvent ||
            scrollEvent.contentOffset.x <
              scrollEvent.contentSize.width -
                scrollEvent.layoutMeasurement.width) && (
            <LinearGradient
              colors={[BACKGROUND_COLOR, 'transparent']}
              start={{ x: 1, y: 0 }}
              end={{ x: 0, y: 0 }}
              style={styles.fadeRight}
            />
          )}
        </>
      )}
    </View>
  );
};

const FADE_WIDTH = 32;

const styles = StyleSheet.create({
  container: { flex: 1 },
  contentContainerSmallScreen: { flex: 1, flexDirection: 'row' },
  contentContainerLargeScreen: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  fadeLeft: {
    width: FADE_WIDTH,
    left: 0,
    height: '100%',
    position: 'absolute',
  },
  fadeRight: {
    width: FADE_WIDTH,
    right: 0,
    height: '100%',
    position: 'absolute',
  },
});
